namespace('arctic.views.group');

compass.require('compass.group.HotelManageListWidget');
compass.require('compass.group.BatchModifyRoomsWidget');
compass.require('compass.group.ListLoaderWidget');
compass.require('compass.group.ConfirmGroupMembersWidget');

compass.requireLib('compass.util.tracking');
compass.require('compass.util.validate');


arctic.views.group.groupManage = function (viewport, options) {
	compass.startLoad('groupManageView');
	var me = this;

	var _viewport = viewport;
	var d = jQuery.dom;
	var $j = jQuery;
	
	var _settings = options;
	var viewData;
	var _searchPaneVisible = false;
	var _preSearchScrollPosition = 0;

	var hotelsContainer;
	var hotelList;
	var searchHotelList;

	var _confirmDialog;

	var hotels;
	var requestsInfo;
	var _unsavedForms = [];/*block ids of assigned room forms that have unsaved changes */

	
	var PROCEED_BTN_TEXT = 'Proceed »';
	var ERROR_MESSAGES = {
		SEARCH: 'We\'re sorry, there was a problem with the search.',
		ASSIGN: 'We\'re sorry, there was a problem updating the reservation.',
		ROOMMATES: 'We\'re sorry, there was a problem adding roommates to the reservation.',
		PAYMENT: 'We\'re sorry, there was a problem changing the payment on the reservation.',
		REQUESTS: 'We\'re sorry, there was a problem adding hotel requests to the reservation.',
		CANCEL: 'We\'re sorry, there was a problem canceling the reservation.',
		CLOSER: 'Please try again. If there is still a problem, you may email customerservice@onpeak.com for assistance.'
	};


	var noNamesHeaderText = 'The room assignment deadline has passed. To proceed, you must assign or cancel all unassigned rooms.';

	var screenSizeMessageText = 'You may edit assigned rooms below, but to view, convert, or release your Group Sub-block unused rooms, please use a larger tablet, laptop or desktop computer.';

	var _clearEvents = function(){
		// This is a temporary fix to help with the fact that binds to the body
		// will never get destroyed via normal means, which was causing weirdness
		var events = [
			'ModifyGroupWidget.submitShares',
			'ModifyGroupWidget.submitPayment',
			'ModifyGroupWidget.submitRequests',
			'ModifyGroupWidget.cancelRoom',
			'BatchModifyRoomsWidget.Cancel',
			CompassEvents.SendConfirmation,
			'ListLoaderSubmissionResultsWidget.ProcessListMember',
			'ListLoaderTransferWidget.UploadList',
			'ListLoaderWidget.DownloadRoster',
			'ListLoaderWidget.GA',
			'CancelRoomWidget.showPolicies'
		];
		_.each(events, function(e) {
			jQuery('body').unbind(e);
		});
	};

	_clearEvents();
	
	var _render = function() {
		compass.loading.stop();
		_viewport.append(d.div({id:'overlay', className: 'inactive'}));
		_viewport.append(_drawHeader());

		var searchHotelsContainer = d.div({className: 'hidden groupHotelsSearchResults'});
		var actionHeader = d.div( {className: 'actionHeader'},
			d.button({name: "finishButton", className: 'proceedButton button'}, PROCEED_BTN_TEXT).activate(_handleProceedButtonClick),
			d.form(_buildSearchBar()),
			d.div({className:'clear'})
		);

		hotelsContainer = d.div({ className: 'hotelsContainer'});
		_viewport.append(actionHeader);
		_viewport.append(d.div({ className: 'testModifyRoomWidgetHolder'}));
		_viewport.append(d.div({className: 'groupManage'},
			hotelsContainer,
			searchHotelsContainer
		));

	};

	var _startLoading = function(obj){
		compass.loading.start($(obj).empty(), { color: '#FFFFFF' });
	};

	var _stopLoading = function(obj, content) {
		compass.loading.stop();
		$(obj).empty().append(content);
	};

	var _sendConfirmation = function() {
		jQuery.ajax({
			data: {
				group_id: viewData.groupInfo.groupBase.group_id
			},
			dataType:'json',
			url:'/sendConfirmation',
			success: function(data) {
			},
			error: function(jqXHR, textStatus, errorThrow) {
				throw new Error('group confo was not sent and sendConfirmation came back with an error');
			}
		});
	};

	var _handleProceedButtonClick = function(event){
		if(_settings.meetingInfo.noNamesDeadlinePassed) {
			var unassignedRoomsByHotel = _.map(_settings.data.hotels, function(hotel) {
				var unassignedRoomsByBlock = _.map(hotel.blockData, function(block) {
					return block.numUnassignedRooms;
				});
				return _.reduce(unassignedRoomsByBlock, function(totalUnassignedRoomsInHotel, unassignedRoomsInBlock) {
					return totalUnassignedRoomsInHotel + unassignedRoomsInBlock;
				});
			});

			var totalUnassignedRooms = _.reduce(unassignedRoomsByHotel, function(total, unassignedRoomsInHotel) {
				return total + unassignedRoomsInHotel;
			});

			if(totalUnassignedRooms > 0) {
				compass.GA.trackEvent('Names - Alert', 'View', 'Names Deadline');
				d.alert({message: noNamesHeaderText, target: false});
				return;
			}

			//if all rooms are assigned then proceed
		}
		if(_unsavedForms.length){
			compass.GA.trackEvent('Names - Alert', 'View', 'Unsaved Changes');
			d.confirm({message:'You have unsaved changes to an unassigned room, proceed without saving?', 
				affirmButtonText : 'Proceed',
				rejectButtonText : 'Let me Finish',
				callback: function(proceed){
					if(!proceed){
						compass.GA.trackEvent('Names - Alert', 'Unsaved - Select', 'Finish Changes');
						/* scroll to the top of the first block */
						var firstUnsavedBlock = $('#' + _unsavedForms[0]);
						$('html, body').animate({
					        scrollTop: (firstUnsavedBlock.offset().top - $('.actionHeader').height())
					    }, 500);
					}
					else{
						compass.GA.trackEvent('Names - Alert', 'Unsaved - Select', 'Proceed');
						_startLoading(event.target);
						_sendConfirmation();
						_navigateTo('frontDesk');
					}
				}
			});
		}
		else{
			_startLoading(event.target);
			_sendConfirmation();
			_navigateTo('frontDesk');
		}

	};

	var _toggleSearchResultsPane = function(show){
		var searchPane = _viewport.find('.groupHotelsSearchResults');
		var mainPane = _viewport.find('.hotelsContainer');
		if(show){
			mainPane.fadeTo( "slow" , 0, function() {
				mainPane.hide();
				compass.loading.stop();
				searchPane.fadeTo("slow", 1, function(){
					_searchPaneVisible = true;
					searchPane.show();
				});
			 });
		}
		else{
			mainPane.show();
			$('.actionHeader').trigger('resize');
			$('html, body').animate({ scrollTop: _preSearchScrollPosition }, 1, function() {
				searchPane.hide();
				_searchPaneVisible = false;
			});
			$j(window).scroll();
			mainPane.fadeTo( 'slow' , 1);
		}
	};

	var _fadeResultsIn = function(){
		var mainPane = _viewport.find('.hotelsContainer');
		var searchPane = _viewport.find('.groupHotelsSearchResults');

		var fadeToNothingPromise;

		/* get to a state where hotels are invisible */
		if(!_searchPaneVisible){
			fadeToNothingPromise = mainPane.fadeTo( "slow" , 0);
		}
		else{
			fadeToNothingPromise = searchPane.fadeTo("slow", 0);
		}

		/*at this point, no matter what, all hotels are invisible */
		/* hide the main pane, fade the results in*/

		$j.when(fadeToNothingPromise).done(function(animdationData, ajaxData){
			searchPane.fadeTo("slow", 1, function(){
				_preSearchScrollPosition = $('body').scrollTop();
				$('html, body').animate({ scrollTop: 0 }, 1);
				mainPane.hide();
				_searchPaneVisible = true;
				compass.loading.stop();
			});
		});
	};

	var _processSearchResults = function(hotels, searchText){
		
		/* prepare the search results for being shown */
		var searchResultsContainer = _viewport.find('.groupHotelsSearchResults');
		searchResultsContainer.empty();
		searchHotelList = new compass.group.HotelManageListWidget(searchResultsContainer, {
			searchText: searchText,
			hotels: hotels,
			meetingInfo: _settings.meetingInfo,
			requestsInfo: requestsInfo,
			cancelInfo: viewData.cancelInfo,
			groupInfo: viewData.groupInfo,
			countriesAndStates: viewData.countriesAndStates,
			cancelReasons : viewData.cancelReasons,
			hideDistance : viewData.hideDistance,
			canSendConfo : viewData.canSendConfo
		});

		_fadeResultsIn();
	};

	var _showProgress = function(){
		var mainPane = _viewport.find('.hotelsContainer');
		var searchPane = _viewport.find('.groupHotelsSearchResults');

		compass.loading.start(null, {zIndex:2999});
		$('.loadingSpinner').prepend(d.div({id: 'searchProcessingMessage'}, 'Searching'));

		if(!_searchPaneVisible){
			/*if main page is up, fade it to 0.5 opacity */
			return mainPane.fadeTo( "slow" , 0.5);
		}
		else{
			/* if search page is fade search page to 0.5 opacity */
			return searchPane.fadeTo("slow", 0.5);
		}
	};

	var _searchTimeout = false;
	var _searchText;
	var _search = function (searchText) {
		/*when we are here, we are firing an ajax request for searching*/
		clearTimeout(_searchTimeout);
		_searchTimeout = false;
		_searchText = searchText;

		var block_ids = _.chain(viewData.hotels).pluck('blockData').flatten().pluck('blockBase').pluck('block_id').value();
		var done_block_ids = [];
		var results = [];

		compass.GA.trackEvent('Group Search', 'Search', 'Name Search');

		var __executeAjaxCalls = function () {
			var dfd = new jQuery.Deferred();
			_showProgress();
			_.each(block_ids,function(block_id,i){
					var block_id_closure = block_id;
					jQuery.ajax({
					data: {"keyword" : searchText,
						   "block_id" : block_id
					},
					dataType: 'json',
					type: 'POST',
					url: '/getGroupReservationData',
					success : function(data){
						done_block_ids;
						done_block_ids.push(block_id_closure);

						results.push({block_id : block_id_closure,  data : data });
						if (_.intersection(done_block_ids, block_ids ).length === block_ids.length){
							dfd.resolve(results);
						}
					},
					error: function() {
						compass.GA.trackEvent('Error', 'View', 'Names - Search Error');
						d.alert({
							message: [d.div({className: 'bold'}, ERROR_MESSAGES.SEARCH), d.div(ERROR_MESSAGES.CLOSER)],
							onClose: function() {
								compass.loading.stop();
								_toggleSearchResultsPane(false);
								_viewport.find('.search').val('');
							}
						});
					}
				});
			});
			return dfd;
		};

		jQuery.when(__executeAjaxCalls()).then(
			function(status){
				var tempSearchHotels = _builSearchResults(results);
				_processSearchResults(tempSearchHotels, searchText);
			}
		);
	
	};

	var _builSearchResults = function(results){
		var newSearchHotels = [];
		var tempSearchHotels = viewData.hotels;
		
		_.each(tempSearchHotels, function(hotel,i){
			// we must deep copy or we will be modifiying the main data.
			var tmpHotel = jQuery.extend(true, {}, hotel);
			_.each(tmpHotel.blockData,function(block,i){
				block.assignedRooms = _.find(results,function(elem){return elem.block_id === block.blockBase.block_id;}).data.names;
			});
			tmpHotel.blockData = _.filter(tmpHotel.blockData, function(block) {
				return block.assignedRooms.length > 0;
			});
			if (tmpHotel.blockData.length > 0) {
				newSearchHotels.push(tmpHotel);
			}
		});
		
		return newSearchHotels;
	};

	var _buildSearchBar = function () {
		var SEARCH_PAUSE = 1*1000;
		var prepSearch = function (event) {
			clearTimeout(_searchTimeout);
			_searchTimeout = false;
			/* we are here when any key is struck */
			if(!event.target.value.length){
				_toggleSearchResultsPane(false);
				return;
			}

			/*...and issue a new ajax request after a pause */
			_searchTimeout = setTimeout(function () { 
				_search(bar.val()); 
			}, 
			SEARCH_PAUSE);
		};
		var bar = d.input({
			className: 'search',
			type: 'text',
			autocomplete: 'off',
			placeholder: 'Search by name',
			onkeydown: function (e) {
				if (e.which === 13 && bar.val() !== '') {
					e.preventDefault();
					_search(bar.val());
				}
			}
		}).bind('input', prepSearch);
		return bar;
	};

	var setupWaypoints = function() {
		
		$('.HotelManageWidget').append(d.div({className: 'footer'},d.div({className: 'borderFooter'})));

		var cards = $(".hotelCardAndPolicyLinkContainer");
		var actionHeader = $(".actionHeader");

		cards.map(function() {
			var card = $(this);
			var foot = $(card.closest(".HotelManageWidget")[0].lastChild);

			card.scrollToFixed({
				marginTop: actionHeader.height() + 10,
				zIndex: 2,
				limit: function() {
					return foot.offset().top - card.outerHeight(true);
				}
			});
		});

		actionHeader.scrollToFixed({
			marginTop: -10,
		});
	};

	var _setupWidgets = function() {

		hotelList = new compass.group.HotelManageListWidget(hotelsContainer, {
			searchMode: false,
			hotels: viewData.hotels,
			meetingInfo: _settings.meetingInfo,
			requestsInfo: requestsInfo,
			cancelInfo: viewData.cancelInfo,
			groupInfo: viewData.groupInfo,
			countriesAndStates: viewData.countriesAndStates,
			cancelReasons : viewData.cancelReasons,
			hideDistance : viewData.hideDistance,
			canSendConfo : viewData.canSendConfo
		});
	};

	var _getHeaderText = function() {
		var totalUnassignedRooms = _getTotalUnassignedRooms();
		var totalRooms = _getTotalRooms();

		var normalHeaderText = 'You must assign names to ' + totalUnassignedRooms + ' rooms by ' + _settings.meetingInfo.noNamesDate + ' or risk losing them.';
		var noUnassignedRoomsText = 'Names have been assigned to all ' + totalRooms + ' rooms.';

		var headerText = _settings.meetingInfo.noNamesDeadlinePassed ? noNamesHeaderText : totalUnassignedRooms === 0 ? noUnassignedRoomsText : normalHeaderText;

		return d.div({ className: 'numberOfRooms' }, headerText);
	};

	var _getChargingNoticeText = function() {

		var failedLinkHandler = function(evt){
			_navigateTo('failedCards');
		};

		var failedCardsLink = d.a({className : 'updateYourPaymentLink', onclick : failedLinkHandler }, 'update your payment');

		var noChargingAtAll = '';
		var serviceFeesPendingTemplate = "Your reservation will be charged a Service &amp; Technology Fee. You can add individual credit cards to assigned rooms now, or charge the entire fee to the primary credit card. All cards on file will be processed today.";
		var serviceFeesSomeFailedTemplate = "Your reservation requires a Service &amp; Technology Fee. We were unable to process some of the credit cards on file. Please ";
		var serviceFeesSomeFailedTemplate2 = " as soon as possible, or risk losing your rooms. You can add individual credit cards to assigned rooms below.";
		var allChargedTemplate = 'Your reservation requires a deposit. The credit cards on file have been successfully processed. Any changes to your reservation may be subject to additional deposit or cancellation charges.';
		var someFailedTemplate = 'Your reservation requires a deposit. We were unable to process some of the credit cards on file. Please ';
		var someFailedTemplate2 = ' as soon as possible, or risk losing your rooms. You can add individual credit cards to assigned rooms below. Any changes to your reservation may be subject to additional deposit or cancellation charges.';
		var companyGuaranteeTemplate = 'Your reservation requires a deposit. You can add individual cards to assigned rooms below. The credit cards on file will be processed once payment is applied. Any changes to your reservation may be subject to additional deposit or cancellation charges.';

		var needToBeChargedTemplate = 'Your reservation requires a deposit. You can add individual credit cards to assigned rooms below. The credit cards on file will be processed <%= minChargeDate %>. Any changes to your reservation may be subject to additional deposit or cancellation charges.';

		var theTemplate;
		var theTemplate2 = "";

		var dateFormatter = compass.util.dateFormatter('full');
		var dateString = 'today';
		var chargingInfo = _settings.data.groupInfo.chargingInfo;

		if (chargingInfo && !chargingInfo.willBeChargedTodayOrEarlier && chargingInfo.minimumChargeDate.length > 0 ) {
			var thedate = compass.util.parse.ISODateParser(chargingInfo.minimumChargeDate);
			dateString = dateFormatter(thedate);
		}

		theTemplate = noChargingAtAll;
		if (chargingInfo && chargingInfo.totalServiceFeesAmount > 0) {
			if (chargingInfo.totalFailedServiceFeesAmount > 0) {
				theTemplate = serviceFeesSomeFailedTemplate;
				theTemplate2 = serviceFeesSomeFailedTemplate2;
			} else if (chargingInfo.totalPendingServiceFeesAmount > 0) {
				theTemplate = serviceFeesPendingTemplate;
			} else {
				theTemplate = "";
			}
		} else if (chargingInfo && chargingInfo.hasCharging ){
			if (chargingInfo.amountDue === 0.00 ) {
				theTemplate = allChargedTemplate;				
			} else if (chargingInfo.failedCards === false && _groupHasCompanyGuarantee()) {
				theTemplate = companyGuaranteeTemplate;
			} else if (chargingInfo.amountDue !== 0.00 && chargingInfo.minimumChargeDate.length > 0) {
				theTemplate = needToBeChargedTemplate;
			} else{
				theTemplate = someFailedTemplate;				
				theTemplate2 = someFailedTemplate2;
			}
		}

		var items = [_.template(theTemplate)({failedCardsLink : failedCardsLink, 
													minChargeDate : dateString
													})];


		if ( theTemplate2.length > 0 ){
			items.push(failedCardsLink);
			items.push(_.template(theTemplate2)({failedCardsLink : failedCardsLink, 
													minChargeDate : dateString
													}));
		}

		return d.div({className:'chargeNoticeTextDiv'},items);
	};

	var _drawHeader = function() {
		return d.div({className: 'headerContainer'},
			d.div({className: 'roomAssignmentHeader'},
				d.div({ className: 'headerTitle'}, 'Room Assignments'),
				d.div({ className: 'roomsToBeAssigned'},
					d.div({ className: 'groupName'}, _settings.data.groupInfo.groupBase.name),
					_getHeaderText()
				),
				d.div({ className: 'chargingNotice' }, _getChargingNoticeText())
			),
			d.div({ className: 'confirmationsButtons'},
				(viewData.canSendConfo === true ? d.div({ className: 'confirmationsButton confirmAndRosterButton'}, d.div({ className: 'linkIcon'}), d.div({ className: 'linkLabel'}, 'Confirm') ).activate(_onClickConfirm) : null ),
				(viewData.hideRosterButton === false ? d.div({ className: 'downloadRosterButton confirmAndRosterButton'}, d.div({ className: 'linkIcon'}), d.div({ className: 'linkLabel'}, 'Roster') ).activate(_onClickRoster) : null ) 
			),
			d.div({ className: 'clear'})
		);
	};

	var _getTotalRooms = function() {
		var hotelData = viewData.hotels;
		var totalRooms = 0;
		
		_.each(hotelData, function(hotel) {
			_.each(hotel.blockData, function(blockData) {
				if(blockData.numTotalRooms) {
					totalRooms += blockData.numTotalRooms;
				}
			});
		});
		
		return totalRooms;
	};

	var _getTotalUnassignedRooms = function() {
		var hotelData = viewData.hotels;
		var totalUnassignedRooms = 0;
		
		_.each(hotelData, function(hotel) {
			_.each(hotel.blockData, function(blockData) {
				if(blockData.numUnassignedRooms) {
					totalUnassignedRooms += blockData.numUnassignedRooms;
				}
			});
		});
		
		return totalUnassignedRooms;
	};

	var _groupHasCompanyGuarantee = function() {
		/* we need to change this to groupInfo.chargingInfo.hasCompanyGuarantee once COM-1758 is released. */
		var paymentInfo = viewData.groupInfo.chargingInfo.payments;
		var hasCompanyGuarantee = _.any(paymentInfo, function(payMethod) {
			return payMethod.code === 'GUARANTEE';
		});
		return hasCompanyGuarantee;
	};

	var _updateTotalUnassignedRooms = function() {
		$j('.headerContainer .roomsToBeAssigned .numberOfRooms').replaceWith(_getHeaderText());
	};

	var _onClickRoster = function() {
		_viewport.trigger('ListLoaderWidget.GA', {action: 'Open Dialog'});
		var listLoaderContainer = d.div();
		var listLoaderWidget = new compass.group.ListLoaderWidget(listLoaderContainer, {
			groupName: _settings.data.groupInfo.groupBase.name,
			isCutoff: _settings.data.groupInfo.listLoaderInfo.isCutoff,
			listLoaderAllowed: _settings.data.groupInfo.listLoaderInfo.listLoaderAllowed,
			commentsAllowed: _settings.data.groupInfo.listLoaderInfo.commentsAllowed
		});

		var _listLoaderDialog = d.dialog({
			centerOnView: true,
			classes: 'ListLoaderDialog',
			modal: true,
			contents: listLoaderContainer,
			showParent: true,
			disableClicksOutsideModal: true
		});
	};

	var _onClickConfirm = function() {
		_drawConfirmDialog();
	};

	var _onClickEditCancel = function() {
		$('html, body').animate({ scrollTop: $('.actionHeader').position().top }, 400);
	};

	var _buildModifyRoomsData = function(data) {
		return {
			hotelName: data.hotelName,
			blockData : data.blocks[0]
		};
	};

	var _setupControls = function() {

	};

	var _drawConfirmDialog = function() {
		if (_confirmDialog) { return; }

		compass.GA.trackEvent('Confirm Members', 'Open', 'Confirm Modal');

		var popup = d.div({});

		var widgConfig = {
			WUID : 'RoomAssignment' + _settings.WUID,
			meetingInfo : _settings.meetingInfo
		};

		var confirmGroupMembersWidget = new compass.group.ConfirmGroupMembersWidget(popup, widgConfig);

		_confirmDialog = d.dialog({
				classes : 'confirmMembersDialog',
				modal : true,
				contents : popup,
				showParent : true
			});
		
		_confirmDialog.bind(_confirmDialog.EVENTS.CLOSE, function () { 
			_confirmDialog = false;
			compass.GA.trackEvent('Confirm Members', 'Close', 'Close Modal');
		});
	};

	var _updateHotels = function(updateData) {
		hotelList.update(updateData);

		if(searchHotelList) {
			var shouldRemoveRoomUpdate = function(roomData, searchText) {
				return roomData.individualBase.email.toLowerCase().indexOf(searchText) < 0 &&
					roomData.individualBase.first_name.toLowerCase().indexOf(searchText) < 0 &&
					roomData.individualBase.last_name.toLowerCase().indexOf(searchText) < 0 &&
					_.all(roomData.roommates, function(roommate) {
						return roommate.individualBase.email.toLowerCase().indexOf(searchText) < 0 &&
							roommate.individualBase.first_name.toLowerCase().indexOf(searchText) < 0 &&
							roommate.individualBase.last_name.toLowerCase().indexOf(searchText) < 0;
					});
			};

			var shouldRemoveRoommateUpdate = function(roommates, searchText) {
				return _.all(roommates, function(roommate) {
					return roommate.first_name.toLowerCase().indexOf(searchText) < 0 &&
						roommate.last_name.toLowerCase().indexOf(searchText) < 0 &&
						roommate.email.toLowerCase().indexOf(searchText) < 0;
				});
			};

			if ((updateData.data.room && shouldRemoveRoomUpdate(updateData.data.room, _searchText.toLowerCase())) ||
				(updateData.data.roommates && shouldRemoveRoommateUpdate(updateData.data.roommates, _searchText.toLowerCase()))) {
				updateData.data = {
					cancel: {},
					success: true
				};
			}
			searchHotelList.update(updateData);
		}
	};

	function checkAutoAssign(data) {
		// Used to check and handle if member dropdown rule is active
		//   and all members have the same reservation details.
		var shouldAutoAssign = false;
		var groupMemberList = data.groupInfo.groupBase.groupMembers.GROUPMEMBERS;

		if (groupMemberList.length > 0 && data.groupInfo.nameAssignmentEnabled === true) {
			// Must be only 1 hotel
			if (data.hotels.length === 1) {
				// Must have only one blocked room
				if (data.hotels[0].blockData.length === 1) {
					var blockData = data.hotels[0].blockData[0];
					// The 1 blocked room must be unassigned
					if (blockData.unassignedRoomsInfo.length === 1) {
						// The amount of this unassigned room must equal or exceed the number of current group members
						if (blockData.unassignedRoomsInfo[0].count >= groupMemberList.length ) {
							shouldAutoAssign = true;
						}
					}
				}
			}
		}

		if (shouldAutoAssign) {
			compass.loading.start();
			jQuery.ajax({
				type: 'POST',
				url: '/autoAssignGroup',
				complete: function() {
					// using COMPLETE since, whether or not the call succeeded, we need to refresh the view for the user
					_reloadView();
				}
			});
		}
		return shouldAutoAssign;
	}

	var _getGroupManageData = function(renderComplete) {
		jQuery.ajax({
			dataType: 'json',
			type: 'GET',
			url: '/groupManage', 
			success: function(data) {
				viewData = data;

				if(data.hotels.length < 1) {
					_sendConfirmation();
					_navigateTo('frontDesk');
				}

				requestsInfo = viewData.requestsInfo;
				hotels = viewData.hotels;
				/* overwrite the noNamesDate; it contains the date gotten with the category permissions vs the original unpermissioned call in entry */
				_settings.meetingInfo.noNamesDate = data.noNamesDate;
				_settings.meetingInfo.noNamesDeadlinePassed = data.noNamesDeadlinePassed;
				_settings.data = data;

				
				

				// If autoassign needs to run, we want to let that call finish
				//   and reload the view. Spinner is in place of regular groupManage 
				//   content to prevent user from doing stuff while the autoassign is 
				//   already running.
				var shouldReload = checkAutoAssign(data);
				if (!shouldReload) {
					_render();
					_setupWidgets();
					_setupControls();
					setupWaypoints();
					compass.stopLoad('groupManageView');
					renderComplete();
				}
			}
		});
	};

	var maxUnfinishedRequests = 1;
	var unfinishedUpdateRequests = [];
	var updateAssignedRoomQueue = [];

	jQuery('.groupManageView').bind('HotelManageWidget.showPolicies', function(event, eventData) {
		compass.GA.trackEvent('Hotel Policies', 'View Policies', 'Name Assignments');
		jQuery.ajax({
			data: { blocked_room_id: eventData.blockRoomIds },
			dataType:'json',
			traditional: true,
			url:'/policies', success : function(data) {
				var policiesDiv = d.div({className:'policiesContainer'});
				_policiesWidget = new compass.hotel.PoliciesWidget(policiesDiv, {
					WUID : 'policiesWidget_individualPersonalInfo',
					policies: data
				});

				_policiesDialog = d.dialog({
					classes: 'personalInfo policiesDialog',
					contents: policiesDiv,
					centerOnView: true
				});
			}
		});
	});

	/*helper function that starts the 'updateMethods' system */
	/* updateMethod is the name of the method that will be called as this notification moves downward through the widgets */
	/* eventData is the data from the original event that was already triggered by a widget */
	/*ajaxResponseData is any data that might have come back from any subsequent ajax calls we made and want to notify widgets of*/
	/*callback is a function to be called once the 'updateMethods' chain of calls is done */
	var _widgetNotify = function(dataObject, eventData, ajaxResponseData, callback)
	{
		/*just a helper function that calls _updateHotels and a callback passed in with */
		/* the original RoomManageWidget.updateAssignedRoom event */
		_updateHotels({
			hotel_id: eventData.hotel_id,
			block_id: eventData.block_id,
			housing_id: eventData.housing_id,
			data: dataObject,
			eventData:eventData
		});
		if(callback){
			callback(ajaxResponseData);
		}
	};

	var _drawOverlay = function(){
		_viewport.find('#overlay').removeClass('inactive');
		_viewport.find('#overlay').animate({ opacity: 0.6 }, 300, "linear");
	};

	var _hideOverlay = function(){
		_viewport.find('#overlay').animate({ opacity: 0 }, 300, "linear", function() {
			_viewport.find('#overlay').addClass('inactive');
		});
	};

	$('.groupManageView').bind('RoomManageWidget.initializeUnassignedRoomChange', function(event, block_id) {
		if(_.indexOf(_unsavedForms, block_id)){
			_unsavedForms.push(block_id);
		}
	});

	$('.groupManageView').bind('RoomManageWidget.InitializeAssignedRoomChange', function(event) {
		_drawOverlay();
	});

	$('.groupManageView').bind('RoomManageWidget.showModifyRoomModal', function(event, eventData) {
		var spinnerDiv = d.div();
		compass.loading.start(spinnerDiv);
		var _loadingDialog = d.dialog({
			width : 0,
			centerOnView : true,
			classes : 'loadingDialog',
			contents: spinnerDiv,
			showCloseButton: false,
			disableClicksOutsideModal : true
		});
		$j.ajax({
			url: '/editRoom',
			data: {
				housing_id: eventData.assignedRoom.reservationBase.housing_id,
				blocked_room_id: eventData.assignedRoom.reservationBase.blocked_room_id,
				hotel_id: eventData.hotelData.hotelBase.hotel_id
			},
			retryLimit: 3,
			success: function(data) {
				eventData.assignedRoom.frequentGuestNumber = data.stay.frequent_guest_number;
				var modifyRoomPopupDiv = d.div();

				// this is hacking and we should start to change /editRoom to return things in a standard way. - ET
				var selectedRoomType = _.find(data.roomTypes, function(room){ return room.blockedRoomId === eventData.assignedRoom.reservationBase.blocked_room_id; });
				eventData.assignedRoom.reservationBase.nights = selectedRoomType.nights;

				var _modifyRoomWidget = new compass.group.ModifyRoomWidget(modifyRoomPopupDiv, {
					WUID: 'nameAssigment_modifyReservationWidget',
					reservationInfo: eventData.assignedRoom,
					stay : data.stay.stay,
					hotelData: eventData.hotelData,
					block_id: eventData.block_id,
					meetingInfo: _settings.meetingInfo,
					requestsInfo: data.requests,
					cancelInfo: {
						cancelFee: data.cancelFee,
						cancelReasons: data.cancelReasons
					},
					groupInfo: eventData.groupInfo,
					countriesAndStates: _settings.data.countriesAndStates,
					initialOptionClass: eventData.tab,
					canCancelBlock: eventData.blockData.canCancel,
					payment: data.payment,
					blockChargeInfo: data.blockChargeInfo,
					memberChargeInfo: data.memberChargeInfo,
					submitCallback: function() {
						_modifyRoomDialog.close();
					}
				});
				
				var _modifyRoomDialog = d.dialog({
					id : eventData.modifyRoomId,
					centerOnView : true,
					classes : 'modifyRoomDialog',
					modal : true,
					contents : modifyRoomPopupDiv,
					showParent : true,
					zIndex: 1020,
					onClose : function() {
					}
				});
				
				_modifyRoomDialog.bind(_modifyRoomDialog.EVENTS.CLOSE, function () {
					compass.GA.trackEvent('Modify Member', 'Close', 'Close Modal');
				});
			},
			complete: function() {
				compass.loading.stop();
				_loadingDialog.close();
			}
		});
	});

	$('.groupManageView').bind('RoomManageWidget.discardChanges', function(event, eventData) {
		compass.GA.trackEvent('Update Assigned', 'Submit', 'Discard Changes');
		_hideOverlay();
		/* need this call so that room manage widget can make its form inactive */
		_widgetNotify({'discardChanges': null}, eventData);

	});

	var processRequestThroughQueue = function(ajaxFunc, ajaxData, updateMethodData){

		var sendRequest = function(updateData, updateSystemData) {
			/*every requst gets added to the list of actively running requests */
			unfinishedUpdateRequests.push(updateData);

			_viewport.find('.proceedButton').addClass('disabled');

			jQuery.when(ajaxFunc(updateData)).done(function(ajaxResponseData) {
				/*when a reuqest is done, we remove it from the list of unfinished requests*/
				unfinishedUpdateRequests = _.reject(unfinishedUpdateRequests, function(request) {
					return request.housing_id === updateData.housing_id;
				});

				/*Remove successful block id changes*/
				if(_.indexOf(_unsavedForms, ajaxData.block_id) != -1){
					_unsavedForms = _.without(_unsavedForms, ajaxData.block_id);
				}

				/* if there's maxUnfinishedRequests still running, don't hide the overlay, but if there's less than that, hide the overlay */
				if(unfinishedUpdateRequests.length < maxUnfinishedRequests) {
					_hideOverlay();
				}
				if(!unfinishedUpdateRequests.length){
					/*if there's no more active requests, enable the proceed button */
					_viewport.find('.proceedButton').removeClass('disabled');
				}

				if (ajaxResponseData.hadBookingIssue === true) {
					updateData.raceConditionFailure();
					return;
				}

				/* CAUTION: This is only done to get around a bug. For some reason, the same widget gets updated twice and one widget gets no updates when 3 requests are present from  */
				/* different widgets*/
				if(updateSystemData.updateKey === 'assignedRooms') {
					updateData.housing_id = ajaxResponseData.assignedRoomData.assignedRoomBase.reservationBase.housing_id;
				} else {
					updateData.housing_id = ajaxResponseData.assignedRoomBase.reservationBase.housing_id;
				}
				// key contains the correct method to call, ie: 'assignedRooms', or 'room'
				var key = updateSystemData.updateKey;
				var dataValue = {};
				// updateSystemData.nodeName sets where to look for necessary data in object structure
				dataValue[key] = ajaxResponseData[updateSystemData.nodeName];
				dataValue.success = true;
				// builds object that can be passed in to _widgetNotify
				updateSystemData.data = dataValue;
				// race condition checking
				_widgetNotify(updateSystemData.data, updateData, ajaxResponseData, updateData.callback);
				
				/*every time a request is done, we check the queue for any other pending requests in the queue and run them*/
				if(updateAssignedRoomQueue.length > 0) {
					sendRequest(updateAssignedRoomQueue.shift());
				}

				if (updateSystemData.updateKey === "assignedRooms") {
					_.each(_settings.data.hotels, function(blocks) {
						_.each(blocks.blockData, function(block) {
							if (block.blockBase.block_id === updateData.block_id) {
								block.numUnassignedRooms -= 1;
							}
						});
					});
				}

				_updateTotalUnassignedRooms();
			}).fail(function(errorMessage, ajaxResponseData){
				_hideOverlay();
				var errorStruct = {error: errorMessage};

				compass.GA.trackEvent('Error', 'View', 'Names - Assign Error');
				d.alert({
					message: [d.div({className: 'bold'}, ERROR_MESSAGES.ASSIGN), d.div(ERROR_MESSAGES.CLOSER)],
					onClose: function() {
						var key = updateSystemData.updateKey;
						var dataValue = {};
						dataValue[key] = ajaxResponseData[updateSystemData.nodeName];
						dataValue.success = false;
						updateSystemData.data = dataValue;
						_widgetNotify(updateSystemData.data, updateData, ajaxResponseData, updateData.callback);
					}
				});
			});
		};

		/* when a new request is issued, we check if we have crossed the threshhold of simultaneous requests 
		/* and if so, we add it to the queue */
		if(unfinishedUpdateRequests.length >= maxUnfinishedRequests) {
			updateAssignedRoomQueue.push(ajaxData, updateMethodData);
			_drawOverlay();
		} else {
			/* we didn't cross the threshold of simultaneous requests, so just run it*/
			_hideOverlay();
			sendRequest(ajaxData, updateMethodData);
		}
	};

	// expects: eventData= { hotel_id, block_id, housing_id, data, callback }
	$('.groupManageView').bind('RoomManageWidget.updateAssignedRoom', function(event, eventData) {
		compass.GA.trackEvent('Update Assigned', 'Submit', 'Save Changes');
		/* if there's maxUnfinishedRequests still running, don't hide the overlay, but if there's less than that, hide the overlay */
		if(unfinishedUpdateRequests.length < maxUnfinishedRequests) {
			_hideOverlay();
		}
		var updateAssignedRoom = function(updateData) {
			var personalInfo = {
				firstName: updateData.assignData.first_name,
				lastName: updateData.assignData.last_name,
				email: updateData.assignData.email
			};

			var data = {
				personal_info : JSON.stringify(personalInfo),
				arrive: updateData.assignData.arrive,
				depart: updateData.assignData.depart,
				blocked_room_id: updateData.assignData.blocked_room_id,
				housing_id: updateData.housing_id,
				context : "roomAssignments",
				responseType : 'assignedRoom'
			};

			return jQuery.ajax({
				data: data,
				type : 'POST',
				url: '/actModify'
			});
		};

		var updateAssignedRoomData = {
			hotel_id: eventData.hotel_id,
			block_id: eventData.block_id,
			housing_id: eventData.housing_id,
			updateKey : 'room',
			nodeName : 'assignedRoomBase',
			callback: function() {}
		};

		processRequestThroughQueue(updateAssignedRoom, eventData, updateAssignedRoomData);
	});

	jQuery('body').bind('ModifyGroupWidget.submitShares', function(event, eventData) {
		compass.GA.trackEvent('Modify Member', 'Update', 'Add Roommates');
		jQuery.ajax({
			data: { shares : JSON.stringify(eventData.sharesData.shares),
					housing_id : eventData.housing_id
				},
			type : 'POST',
			url: '/actShares',
			success: function(data) {
				_widgetNotify({'roommates': data.SHARESARRAY, success: true},
		 			eventData, data.SHARESARRAY, eventData.callback);
			},
			error: function() {
				compass.GA.trackEvent('Error', 'View', 'Names - Roommates Error');
				d.alert({
					message: [d.div({className: 'bold'}, ERROR_MESSAGES.ROOMMATES), d.div(ERROR_MESSAGES.CLOSER)],
					onClose: function() {
						_widgetNotify({'roommates': data.SHARESARRAY, success: false},
				 			eventData, data.SHARESARRAY);
					}
				});
			}
		});
	});

	jQuery('body').bind('ModifyGroupWidget.submitPayment', function(event, eventData) {
		compass.GA.trackEvent('Modify Member', 'Update', 'Apply Payment');
		var data = {
			payment_info : JSON.stringify(eventData.paymentData.payment),
			housing_id: eventData.housing_id,
			context : "roomAssignments",
			responseType : 'assignedRoom'
		};

		jQuery.ajax({
			data: data,
			type : 'POST',
			url: '/actModify',
			success: function(data) {
				_widgetNotify({'payment': data, success: true},
		 			eventData, data, eventData.callback);
			},
			error: function() {
				compass.GA.trackEvent('Error', 'View', 'Names - Payment Error');
				d.alert({
					message: [d.div({className: 'bold'}, ERROR_MESSAGES.PAYMENT), d.div(ERROR_MESSAGES.CLOSER)],
					onClose: function() {
						_widgetNotify({'payment': data, success: false},
				 			eventData, data);
					}
				});
			}
		});
	});

	jQuery('body').bind('ModifyGroupWidget.submitRequests', function(event, eventData) {
		compass.GA.trackEvent('Modify Member', 'Update', 'Submit Requests');
		jQuery.ajax({
			data: {
				requests : JSON.stringify(eventData.requests.requests),
				housing_id: eventData.requests.housing_id,
				notes : eventData.requests.notes,
				frequentGuestNumber: eventData.requests.frequentGuestNumber
			},
			dataType: 'json',
			url: '/saveRequests',
			type: 'POST',
			success: function(data) {
				_widgetNotify({'requests': data, success: true},
					eventData, data, eventData.callback);
			},
			error: function() {
				compass.GA.trackEvent('Error', 'View', 'Names - Requests Error');
				d.alert({
					message: [d.div({className: 'bold'}, ERROR_MESSAGES.REQUESTS), d.div(ERROR_MESSAGES.CLOSER)],
					onClose: function() {
						_widgetNotify({'requests': data, success: false},
				 			eventData, data);
					}
				});
			}
		});
	});

	jQuery('body').bind('ModifyGroupWidget.cancelRoom', function(event, eventData) {
		compass.GA.trackEvent('Modify Member', 'Update', 'Cancel Reservation');
		var cancelData = eventData.cancelData;
		cancelData.housing_id = eventData.housing_id;

		jQuery.ajax({
			data: cancelData,
			type : 'POST',
			url: '/actCancel',
			success : function(data){

				_updateHotels({
					hotel_id: eventData.hotel_id,
					block_id: eventData.block_id,
					housing_id: eventData.housing_id,
					data: {
						cancel: {},
						success: true
					}
				});
				
				if (!_settings.meetingInfo.noNamesDeadlinePassed) {
					_.each(_settings.data.hotels, function(hotel) {
						if(hotel.hotelData.hotelBase.hotel_id === eventData.hotel_id) {
							_.each(hotel.blockData, function(block) {
								if(block.blockBase.block_id === eventData.block_id) {
									block.numAssignedRooms--;
									block.numUnassignedRooms++;
								}
							});
						}
					});
				}

				_updateTotalUnassignedRooms();

				eventData.callback();
			},
			error: function() {
				compass.GA.trackEvent('Error', 'View', 'Names - Cancel Error');
				d.alert({
					message: [d.div({className: 'bold'}, ERROR_MESSAGES.CANCEL), d.div(ERROR_MESSAGES.CLOSER)],
					onClose: function() {
						_updateHotels({
							hotel_id: eventData.hotel_id,
							block_id: eventData.block_id,
							housing_id: eventData.housing_id,
							data: {
								cancel: {},
								success: false
							}
						});
					}
				});
			}
		});
	});

	//Copy over from roomAssignments
	jQuery('body').bind(CompassEvents.SendConfirmation, function(evt, data) {
		compass.GA.trackEvent('Confirm Members', 'Send Confirmations', 'Group Member Confos');

		jQuery.ajax({
			url: '/queueGroupMemberConfos',
			type: 'POST',
			data: {'confirmAllMembers' : 'N', "confirmUniqueEmails" : "Y"},
			success: function (data) {
				$('body').find('.confirmButton').html('Members Confirmed').addClass('successfulConfirm');
				setTimeout(function() {
					$('body').find('.confirmMembersDialog').remove();
				}, 1500);

			}
		});
	});

	jQuery('.groupManageView').bind('_expandBlock', function(event, expandBlockData) {
		/* gets the data for just one block*/
		jQuery.ajax({
			data: expandBlockData.data,
			dataType: 'json',
			type: 'GET',
			url: '/getGroupReservationData',
			success: function(blockData) {
				expandBlockData.onSuccess(blockData);
			}
		});
	});

	jQuery('.groupManageView').bind('RoomManageWidget.AssignRoom', function(event, eventData) {
		compass.GA.trackEvent('Update Unassigned', 'Submit', 'Assign Room');
		_viewport.find('.proceedButton').addClass('disabled');
		var assignRoom = function(updateData) {
			return jQuery.ajax({
				data: { 
						blocked_room_id: updateData.assignData.blocked_room_id,
						arrive: updateData.assignData.arrive,
						depart: updateData.assignData.depart,
						first_name: updateData.assignData.first_name,
						last_name: updateData.assignData.last_name,
						email: updateData.assignData.email,
						attendance_id: updateData.assignData.attendance_id || undefined
				},
				dataType: 'json',
				type: 'POST',
				url: '/assignRoom',
				complete: function(){
					_viewport.find('.proceedButton').removeClass('disabled');
				}
			});
		};

		var updateAssignRoomData = {
			hotel_id: eventData.hotel_id,
			block_id: eventData.block_id,
			housing_id: eventData.housing_id,
			updateKey : 'assignedRooms',
			nodeName : 'assignedRoomData',
			callback: function() {}
		};

		processRequestThroughQueue(assignRoom, eventData, updateAssignRoomData);
	});

 	jQuery('.groupManageView').bind('RoomManageWidget.requestRoomTypes', function(event, eventData) {
		compass.loading.start();
		jQuery.ajax({
			data : eventData.data,
			dataType: 'json',
			url: '/getRoomTypes',
			success: eventData.dataHandler,
			complete: function() {
				compass.loading.stop();
			}
		});
	});

	jQuery('.groupManageView').bind('RoomManageWidget.SendGroupMemberConfo', function(event, eventData) {
		jQuery.ajax({
			data: JSON.stringify(eventData),
			contentType: 'application/json',
			method: 'POST',
			url: '/sendConfirmation',
			success: function(data) {
				compass.GA.trackEvent('Update Assigned', 'Click send individual email', 'Email sent');
			},
			error: function() {
				d.alert('We were unable to send the confirmation email. Please try again.');
				compass.GA.trackEvent('Update Assigned', 'Click send individual email', 'Email error message');
			},
			complete: function() {
				eventData.hideLoadingOverlay();
			}
		});
	});

	var _unfinishedBatchCancelRequest;


	var _processNextBatchCancel = function(data) {
		if (data === undefined || data.moreWorkToDo === true) {
			var postData = { params : JSON.stringify(_unfinishedBatchCancelRequest) };
			jQuery.ajax({
				url: '/batchCancel',
				type : 'POST',
				data: postData,
				success: _processNextBatchCancel
			});
		} else {
			_reloadView();
		}
	};

	jQuery('body').bind('BatchModifyRoomsWidget.Cancel', function(event, eventData) {
		_unfinishedBatchCancelRequest = eventData;
		_processNextBatchCancel();
	});

	jQuery('.groupManageView').bind('HotelManageListWidget.lastHotelRemoved', function(event) {
		_sendConfirmation();
		_navigateTo('frontDesk');
	});

	$j('body').bind('ListLoaderWidget.DownloadRoster', function(event, eventData) {
		var _checkDownloadInterval;
		var interval = 250;
		var button = eventData.button;
		Cookies.set('download', false, { path: '/'});
		window.location = window.location.pathname+'/downloadList';
		button.addClass('disabled');
		compass.loading.start(button.empty(), { color : '#FFFFFF' });
		_checkDownloadInterval = setInterval(function() {
			if (Cookies.get('download') === 'true') {
				compass.loading.stop();
				button.removeClass('disabled');
				button.append(eventData.buttonText);
				clearInterval(_checkDownloadInterval);
				Cookies.remove('download', { path: '/' });
			}
		}, interval);
	});

	$j('body').bind('ListLoaderTransferWidget.UploadList', function(event, eventData) {
		$j.ajax({
			data: eventData.file,
			type: 'POST',
			url: '/uploadList',
			cache: false,
			contentType: false,
			processData: false,
			success: function(data) {
				if (data.valid === true) {
					eventData.callback(data);
				} else {
					eventData.errorCallback();
				}
			},
			error: function() {
				eventData.errorCallback();
			}
		});
	});

	$j('body').bind('ListLoaderSubmissionResultsWidget.ProcessListMember', function(event, eventData) {
		_processListMember(eventData);
	});

	jQuery('body').bind('BatchModifyRoomsWidget.showPolicies', function(event, eventData) {
		jQuery.ajax({
			data: { blocked_room_id: eventData.blockedRoomIds },
			dataType:'json',
			traditional: true,
			url:'/policies',
			success : function(data) {
				var policiesDiv = d.div({className:'policiesContainer'});
				_policiesWidget = new compass.hotel.PoliciesWidget(policiesDiv, {
					WUID : 'policiesWidget_groupManage',
					policies: data
				});

				_policiesDialog = d.dialog({
					classes: 'groupManage policiesDialog',
					contents: policiesDiv,
					centerOnView: true
				});
			}
		});
	});

	var _processListMember = function(listData) {
		$j.ajax({
			data: {list_id: listData.list_id},
			type: 'GET',
			dataType: 'json',
			url: '/processListMember',
			success: function(data) {
				$j('.ListLoaderProcessingWidget').trigger('ListLoaderProcessingWidget.updateProcessedReservations', {processed: data.processed, total: data.total});
				if (data.moreToDo) {
					_processListMember(listData);
				} else {
					$j('.ListLoaderProcessingWidget').trigger('ListLoaderProcessingWidget.finishProcessing');
				}
			},
			error: function() {
				$j('.ListLoaderProcessingWidget').trigger('ListLoaderProcessingWidget.errorProcessing');
			}
		});
	};

	$j('body').bind('ListLoaderWidget.GA', function(event, eventData) {
		compass.GA.trackEvent('Roster', eventData.action, 'Names Page');
	});

	var _reloadView = function() {
		window.location.reload();
	};

	var _navigateTo = function(route) {
		_clearEvents();
		_viewport.trigger(CompassEvents.Navigate, route);
	};

	this.run = function(renderComplete) {
		compass.loading.start();
		_getGroupManageData(renderComplete);
	};
};
